import { createServerFn } from "@tanstack/react-start";
import * as z from "zod";

import { getRequestLogger, logRequestError } from "#/lib/requestLogger.server";
import { authedMiddleware } from "#/server/authedMiddleware";
import { requireClerkBillingUser } from "#/server/billing/clerkBillingUser";
import { setMarketingEmailsForPlayer } from "#/server/marketing/setMarketingEmailsForPlayer.server";

const updateMarketingEmailsSettingInputSchema = z.object({
  enabled: z.boolean(),
});

export const updateMyMarketingEmailsSetting = createServerFn({ method: "POST" })
  .middleware([authedMiddleware])
  .validator(updateMarketingEmailsSettingInputSchema)
  .handler(async ({ data }) => {
    getRequestLogger().set({
      profile: { action: "update_marketing_emails_setting", enabled: data.enabled },
    });
    try {
      const { userId, email } = await requireClerkBillingUser();
      await setMarketingEmailsForPlayer({
        playerId: userId,
        email,
        enabled: data.enabled,
      });
    } catch (error) {
      logRequestError({
        log: getRequestLogger(),
        error,
        context: { profile: { step: "update_marketing_emails_setting" } },
      });
      throw error;
    }
  });
